import moment, { Moment } from "moment";

export const price = (value: any) => {
  return Number(value).toLocaleString("pt-BR", {
    currency: "BRL",
    style: "currency",
  });
};

export function urlify(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + "</a>";
  });
};

export function formatData(data: Moment, format = "DD/MM/YYYY HH:mm:ss"){
  return moment(data, "YYYY-MM-DD HH:mm:ss").format(format);
};

export function translateStatusSocialNetworks(status = "") {
  switch (status) {
    case "post_reactions_by_type_total":
    case "likes_count":
      return "Reações";
    case "post_impressions":
    case "impressions":
      return "Visualizações";
    case "post_impressions_paid":
      return "Visualizações pagas";
    case "post_engaged_users":
    case "engagament":
      return "Engajamento";
    case "post_impressions_unique":
    case "reach":
      return "Contas atingidas";
    case "saved":
      return "Salvos";
    case "comments_count":
      return "Comentários";
    default:
      return "";
  }
}

export function translateStatusPaidFacebook(status = "") {
  switch (status) {
    case "clicks":
      return "Cliques";
    case "impressions":
      return "Visualizações";
    case "frequency":
      return "Frequência (Por pessoa)";
    case "reach":
      return "Contas atingidas";
    case "cost_per_inline_link_click":
      return "Custo por resultado (Cliques)";
    default:
      return "";
  }
}

export function translateStatusSends(status: any) {
  switch (status.toUpperCase()) {
    case "AGUARDANDO":
      return "wait";
    case "ENVIADO SEM CONFIRMACAO":
    case "ENVIADO":
    case "CONFIRMACAO INDISPONIVEL":
    case "MENSAGEM EM ANALISE":
      return "sent";
    case "ENVIADO COM CONFIRMACAO":
    case "CONFIRMADO":
      return "received";
    case "MENSAGEM ABERTA":
      return "read";
    case "MENSAGEM ENTREGUE":
      return "delived_unread";
    case "CANCELADO":
    case "CANCELADA":
    case "CANCELADO TEMPORARIAMENTE":
      return "canceled";
    case "ERRO":
    case "NAO ENTREGUE":
    case "MENSAGEM INVALIDA":
    case "DESTINATARIO INVALIDO":
    case "TENTATIVA ENVIO DUPLICADO":
    case "ENVIO INVALIDO":
    case "ENVIO BLOQUEADO":
      return "error";
    case "MENSAGEM CLICADA":
      return "clicks";
    case "SPAM":
      return "spam";
    default:
      return "wait";
  }
}
